import { render, staticRenderFns } from "./HomeViewSOS.vue?vue&type=template&id=64eea922&scoped=true&"
import script from "./HomeViewSOS.vue?vue&type=script&lang=js&"
export * from "./HomeViewSOS.vue?vue&type=script&lang=js&"
import style0 from "./HomeViewSOS.vue?vue&type=style&index=0&id=64eea922&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64eea922",
  null
  
)

export default component.exports